import { Asset } from '../asset';

export class RuleAction {
    id: number;
    method = 'set';
    trigger: string;
    asset: Asset;
    deviceAction: IRuleDeviceAction;
    value: string;
    device_action_id?: number;
    device_action_title?: string;
    device: any;

    constructor(data?: any) {

        if (data?.device_action_id) {
            this.id = data.id;
            this.method = data.method;
            this.device_action_id = data.device_action_id;
            this.deviceAction = {
                id: data.device_action_id,
                deviceTitle: data.device_title,
                actionTitle: data.device_action_title,
                gateway_id: data.device_action_gateway_id
            };
            this.device_action_title = data.device_action_title;
            this.trigger = data.trigger;
        } else if (data) {
            this.id = data.id;
            this.method = data.method;
            this.value = data.value;
            this.trigger = data.trigger;
            this.asset = new Asset(
                {
                    id: data.asset_id,
                    title: data.assetTitle,
                    gateway_id: data.gatewayId,
                    gatewayTitle: data.gatewayTitle,
                    siteId: data.siteId,
                    siteTitle: data.siteTitle
                }
            );
        } else {
            this.asset = new Asset();
        }
    }
}


export interface IRuleDeviceAction {
    id: number;
    deviceTitle: string;
    actionTitle: string;
    gateway_id: string;
}
